/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { TabPanel } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { __SelectPaises } from "request/configuration/_Country";
import { TabsAdvanced } from "components/Tabs-Pestañas/TabsAdvanced";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import FormDocumentsCorrect from "./FormDocumentsCorrect";
import FormVencimientCorrect from "./FormVencimientCorrect";
import FormAcumuladoCorrect from "./FormAcumuladoCorrect";
import { FormDocumentsCorrectOutput } from "./FormDocumentsCorrectOutput";
import { __Get } from "request/Petitions/__Get";
import environment from "constants/apiConst";
import FormItems from "pages/Entry_and_exit_forms/View/AdvancedSearch/FormsAdvancedSearch/FormItems";

const FormSearchAdvanceCorrect = ({
  onClose,
  setSearchAdvanced,
  setValueThird,
  valueThird,
  selectUF,
  setSelectUF,
  operationT,
  seOperationT,
  sortBy,
  setSortBy,
  selectAD,
  setSelectAD,
  setRefund,
  refund,
  setDispacth,
  dispacth,
  setBalance,
  balance,
  setReposition,
  reposition,
  searchItems
}) => {
  const location = useLocation();
  const { movement = "" } = queryString.parse(location.search);

  const [positionView, setPositionView] = useState(0);
  const [dataCountry, setDataCountry] = useState([]);
  const [dataTypeOperation, setDataTypeOperation] = useState(null);

  const token = useSelector((state) => state.auth.dataUser.token);

  useEffect(() => {
    getCountry();
  }, []);

  const getCountry = async () => {
    try {
      const res = await __SelectPaises(token);
      const indoCountry = res?.data?.status?.data.map((item) => ({
        value: item?.id,
        label: item?.code_country + " " + item?.name_country
      }));
      setDataCountry(indoCountry);
    } catch (error) {}
  };

  const handleCambio = (index) => {
    setPositionView(index);
  };

  const arrayHeadEntry = [
    "Documentos",
    "Items",
    "Vencimientos",
    "Acumulados Báscula"
  ];

  const arrayHeadExit = ["Documentos", "Items", "Temporales", "Vencimientos"];

  useEffect(() => {
    obtenerTypeOperation();
  }, []);

  const obtenerTypeOperation = async () => {
    try {
      const res = await __Get(environment.TYPE_OPERATION_LIST, token);
      if (res.data.status.code === 200) {
        const infoOperation = res?.data?.status?.data.map((item) => ({
          value: item?.id,
          label: item?.name_typeOperation
        }));

        setDataTypeOperation(infoOperation);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {movement === "Corregido de ingreso" ? (
        <TabsAdvanced handleCambio={handleCambio} arrayHead={arrayHeadEntry}>
          <TabPanel>
            <FormDocumentsCorrect
              onClose={onClose}
              handleSubmit={setSearchAdvanced}
              setValueThird={setValueThird}
              valueThird={valueThird}
              selectUF={selectUF}
              setSelectUF={setSelectUF}
              operationT={operationT}
              seOperationT={seOperationT}
              sortBy={sortBy}
              setSortBy={setSortBy}
              selectAD={selectAD}
              setSelectAD={setSelectAD}
              position={positionView}
              dataTypeOperation={dataTypeOperation}
            />
          </TabPanel>
          <TabPanel>
            <FormItems
              dataCountry={dataCountry}
              searchItems={searchItems}
              onClose={onClose}
              setValueThird={setValueThird}
              valueThird={valueThird}
              selectUF={selectUF}
              operationT={operationT}
              seOperationT={seOperationT}
              sortBy={sortBy}
              setSortBy={setSortBy}
              selectAD={selectAD}
              setSelectAD={setSelectAD}
            />
          </TabPanel>
          <TabPanel>
            <FormVencimientCorrect />
          </TabPanel>
          <TabPanel>
            <FormAcumuladoCorrect />
          </TabPanel>
        </TabsAdvanced>
      ) : (
        <TabsAdvanced handleCambio={handleCambio} arrayHead={arrayHeadExit}>
          <TabPanel>
            <FormDocumentsCorrectOutput
              position={positionView}
              onClose={onClose}
              handleSubmit={setSearchAdvanced}
              setValueThird={setValueThird}
              valueThird={valueThird}
              selectUF={selectUF}
              setSelectUF={setSelectUF}
              operationT={operationT}
              seOperationT={seOperationT}
              sortBy={sortBy}
              setSortBy={setSortBy}
              selectAD={selectAD}
              setSelectAD={setSelectAD}
              dataTypeOperation={dataTypeOperation}
              setRefund={setRefund}
              refund={refund}
              setDispacth={setDispacth}
              dispacth={dispacth}
            />
          </TabPanel>
          <TabPanel>
            <FormItems
              dataCountry={dataCountry}
              searchItems={searchItems}
              onClose={onClose}
              setValueThird={setValueThird}
              valueThird={valueThird}
              selectUF={selectUF}
              operationT={operationT}
              seOperationT={seOperationT}
              sortBy={sortBy}
              setSortBy={setSortBy}
              selectAD={selectAD}
              setSelectAD={setSelectAD}
              setRefund={setRefund}
              refund={refund}
            />
          </TabPanel>
          <TabPanel>
            vacio
            {/* <FormVencimientos /> */}
          </TabPanel>
          <TabPanel>
            vacio
            {/* <FormAcumulados /> */}
          </TabPanel>
        </TabsAdvanced>
      )}
    </>
  );
};

export default FormSearchAdvanceCorrect;
